export const PHONE_DISPLAY = "(704) 380-7309";
export const WHATSAPP_NUMBER = "17043807309";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi C Duarte Home Pro! I'd like to request a free, no-obligation quote."
)}`;
export const SMS_URL = `sms:7043807309?&body=${encodeURIComponent(
  "Hi C Duarte Home Pro! I'd like to request a free, no-obligation quote."
)}`;
export const INSTAGRAM_HANDLE = "@cduartehomepro";
export const INSTAGRAM_URL = "https://www.instagram.com/cduartehomepro/";
export const FACEBOOK_URL = "#";
export const EMAIL = "contact@cduartehomepro.com";
export const CITY = "Charlotte, NC";
export const LOGO = "/cduarte-logo-official.jpg";
export const LOGO_ICON = "/cduarte-icon.png";
export const ELEMENT_WRENCH = "/element-wrench.png";
export const ELEMENT_SPRAY = "/element-spray.png";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/28586197/pexels-photo-28586197.jpeg?auto=compress&cs=tinysrgb&w=1920",
  handyman:
    "https://images.pexels.com/photos/5768284/pexels-photo-5768284.jpeg?auto=compress&cs=tinysrgb&w=1200",
  cleaning:
    "https://images.pexels.com/photos/6195274/pexels-photo-6195274.jpeg?auto=compress&cs=tinysrgb&w=1200",
  commercial:
    "https://images.unsplash.com/photo-1781637590564-01c65dbf2039?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  family: "/gallery/team-cduarte.jpg",
  gallery: [
    { src: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", label: "Living Room Refresh", tag: "Cleaning" },
    { src: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", label: "Bathroom & Kitchen Remodeling", tag: "Repairs" },
    { src: "https://images.unsplash.com/photo-1606676539940-12768ce0e762?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", label: "Flooring Replacement", tag: "Repairs" },
    { src: "https://images.unsplash.com/photo-1758273705627-937374bfa978?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", label: "House Cleaning", tag: "Cleaning" },
    { src: "https://images.unsplash.com/photo-1563453392212-326f5e854473?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", label: "Deep Cleaning", tag: "Cleaning" },
    { src: "https://images.pexels.com/photos/6196694/pexels-photo-6196694.jpeg?auto=compress&cs=tinysrgb&w=1000", label: "Deep Floor Clean", tag: "Cleaning" },
    { src: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", label: "Move-Out Sparkle", tag: "Cleaning" },
  ],
  beforeAfter: [
    { label: "Stove / Cooktop", before: "/gallery/stove_before.jpg", after: "/gallery/stove_after.jpg" },
    { label: "Microwave", before: "/gallery/microwave_before.jpg", after: "/gallery/microwave_after.jpg" },
    { label: "Door / Baseboard Trim", before: "/gallery/door_before.jpg", after: "/gallery/door_after.jpg" },
  ],
};

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Work", href: "#gallery" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];
